import React, { useEffect, useState } from 'react';

const STEPS = [0.875, 1, 1.125, 1.25, 1.375, 1.5];
const keyOf = (p) => `tagws_font_scale:${p?.id || p?.email || 'anon'}`;

// Header A− / A+ : scales only the portal's text (not the layout) for this user on this device.
export function TagFontSize({ principal }) {
  const [i, setI] = useState(() => { const v = Number(localStorage.getItem(keyOf(principal))); const at = STEPS.indexOf(v); return at < 0 ? 1 : at; });
  useEffect(() => {
    document.documentElement.style.setProperty('--fs', String(STEPS[i]));
    localStorage.setItem(keyOf(principal), String(STEPS[i]));
  }, [i, principal]);
  useEffect(() => () => { document.documentElement.style.removeProperty('--fs'); }, []);
  const btn = 'grid h-8 min-w-8 place-items-center rounded-md px-1.5 font-semibold text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground disabled:opacity-30';
  return (
    <div className="flex items-center rounded-lg border border-border bg-card" role="group" aria-label="Text size" data-testid="tagws-font-size">
      <button type="button" onClick={() => setI(i - 1)} disabled={i === 0} title="Smaller text" aria-label="Smaller text" className={`${btn} text-[length:calc(var(--fs,1)*0.75rem)]`} data-testid="tagws-font-smaller">A−</button>
      <button type="button" onClick={() => setI(1)} title="Normal size" className="min-w-10 text-center text-[length:calc(var(--fs,1)*0.6875rem)] tabular-nums text-muted-foreground hover:text-foreground" data-testid="tagws-font-value">{Math.round(STEPS[i] * 100)}%</button>
      <button type="button" onClick={() => setI(i + 1)} disabled={i === STEPS.length - 1} title="Larger text" aria-label="Larger text" className={`${btn} text-[length:calc(var(--fs,1)*0.9375rem)]`} data-testid="tagws-font-larger">A+</button>
    </div>
  );
}
